import { ReactComponent as Icon_add_user } from "src/assets/icons/pe7/add-user.svg";
import { ReactComponent as Icon_alarm } from "src/assets/icons/pe7/alarm.svg";
import { ReactComponent as Icon_albums } from "src/assets/icons/pe7/albums.svg";
import { ReactComponent as Icon_angle_down } from "src/assets/icons/pe7/angle-down.svg";
import { ReactComponent as Icon_angle_left_circle } from "src/assets/icons/pe7/angle-left-circle.svg";
import { ReactComponent as Icon_angle_right_circle } from "src/assets/icons/pe7/angle-right-circle.svg";
import { ReactComponent as Icon_angle_up } from "src/assets/icons/pe7/angle-up.svg";
import { ReactComponent as Icon_attention } from "src/assets/icons/pe7/attention.svg";
import { ReactComponent as Icon_back } from "src/assets/icons/pe7/back.svg";
import { ReactComponent as Icon_ball } from "src/assets/icons/pe7/ball.svg";
import { ReactComponent as Icon_bell } from "src/assets/icons/pe7/bell.svg";
import { ReactComponent as Icon_bookmarks } from "src/assets/icons/pe7/bookmarks.svg";
import { ReactComponent as Icon_box2 } from "src/assets/icons/pe7/box2.svg";
import { ReactComponent as Icon_car } from "src/assets/icons/pe7/car.svg";
import { ReactComponent as Icon_cart } from "src/assets/icons/pe7/cart.svg";
import { ReactComponent as Icon_cash } from "src/assets/icons/pe7/cash.svg";
import { ReactComponent as Icon_chat } from "src/assets/icons/pe7/chat.svg";
import { ReactComponent as Icon_check } from "src/assets/icons/pe7/check.svg";
import { ReactComponent as Icon_close } from "src/assets/icons/pe7/close.svg";
import { ReactComponent as Icon_cloud } from "src/assets/icons/pe7/cloud.svg";
import { ReactComponent as Icon_coffee } from "src/assets/icons/pe7/coffee.svg";
import { ReactComponent as Icon_comment } from "src/assets/icons/pe7/comment.svg";
import { ReactComponent as Icon_config } from "src/assets/icons/pe7/config.svg";
import { ReactComponent as Icon_copy_file } from "src/assets/icons/pe7/copy-file.svg";
import { ReactComponent as Icon_credit } from "src/assets/icons/pe7/credit.svg";
import { ReactComponent as Icon_cup } from "src/assets/icons/pe7/cup.svg";
import { ReactComponent as Icon_delete_user } from "src/assets/icons/pe7/delete-user.svg";
import { ReactComponent as Icon_diamond } from "src/assets/icons/pe7/diamond.svg";
import { ReactComponent as Icon_display1 } from "src/assets/icons/pe7/display1.svg";
import { ReactComponent as Icon_display2 } from "src/assets/icons/pe7/display2.svg";
import { ReactComponent as Icon_download } from "src/assets/icons/pe7/download.svg";
import { ReactComponent as Icon_drawer } from "src/assets/icons/pe7/drawer.svg";
import { ReactComponent as Icon_edit } from "src/assets/icons/pe7/edit.svg";
import { ReactComponent as Icon_filter } from "src/assets/icons/pe7/filter.svg";
import { ReactComponent as Icon_folder } from "src/assets/icons/pe7/folder.svg";
import { ReactComponent as Icon_gift } from "src/assets/icons/pe7/gift.svg";
import { ReactComponent as Icon_graph } from "src/assets/icons/pe7/graph.svg";
import { ReactComponent as Icon_graph1 } from "src/assets/icons/pe7/graph1.svg";
import { ReactComponent as Icon_graph2 } from "src/assets/icons/pe7/graph2.svg";
import { ReactComponent as Icon_gym } from "src/assets/icons/pe7/gym.svg";
import { ReactComponent as Icon_help1 } from "src/assets/icons/pe7/help1.svg";
import { ReactComponent as Icon_home } from "src/assets/icons/pe7/home.svg";
import { ReactComponent as Icon_id } from "src/assets/icons/pe7/id.svg";
import { ReactComponent as Icon_lock } from "src/assets/icons/pe7/lock.svg";
import { ReactComponent as Icon_magic_wand } from "src/assets/icons/pe7/magic-wand.svg";
import { ReactComponent as Icon_mail } from "src/assets/icons/pe7/mail.svg";
import { ReactComponent as Icon_map } from "src/assets/icons/pe7/map.svg";
import { ReactComponent as Icon_medal } from "src/assets/icons/pe7/medal.svg";
import { ReactComponent as Icon_monitor } from "src/assets/icons/pe7/monitor.svg";
import { ReactComponent as Icon_network } from "src/assets/icons/pe7/network.svg";
import { ReactComponent as Icon_news_paper } from "src/assets/icons/pe7/news-paper.svg";
import { ReactComponent as Icon_next } from "src/assets/icons/pe7/next.svg";
import { ReactComponent as Icon_note2 } from "src/assets/icons/pe7/note2.svg";
import { ReactComponent as Icon_notebook } from "src/assets/icons/pe7/notebook.svg";
import { ReactComponent as Icon_phone } from "src/assets/icons/pe7/phone.svg";
import { ReactComponent as Icon_photo_gallery } from "src/assets/icons/pe7/photo-gallery.svg";
import { ReactComponent as Icon_piggy } from "src/assets/icons/pe7/piggy.svg";
import { ReactComponent as Icon_plane } from "src/assets/icons/pe7/plane.svg";
import { ReactComponent as Icon_plugin } from "src/assets/icons/pe7/plugin.svg";
import { ReactComponent as Icon_plus } from "src/assets/icons/pe7/plus.svg";
import { ReactComponent as Icon_refresh } from "src/assets/icons/pe7/refresh.svg";
import { ReactComponent as Icon_repeat } from "src/assets/icons/pe7/repeat.svg";
import { ReactComponent as Icon_settings } from "src/assets/icons/pe7/settings.svg";
import { ReactComponent as Icon_shopbag } from "src/assets/icons/pe7/shopbag.svg";
import { ReactComponent as Icon_shuffle } from "src/assets/icons/pe7/shuffle.svg";
import { ReactComponent as Icon_smile } from "src/assets/icons/pe7/smile.svg";
import { ReactComponent as Icon_star } from "src/assets/icons/pe7/star.svg";
import { ReactComponent as Icon_study } from "src/assets/icons/pe7/study.svg";
import { ReactComponent as Icon_sun } from "src/assets/icons/pe7/sun.svg";
import { ReactComponent as Icon_tools } from "src/assets/icons/pe7/tools.svg";
import { ReactComponent as Icon_unlock } from "src/assets/icons/pe7/unlock.svg";
import { ReactComponent as Icon_user } from "src/assets/icons/pe7/user.svg";
import { ReactComponent as Icon_users } from "src/assets/icons/pe7/users.svg";
import { ReactComponent as Icon_wallet } from "src/assets/icons/pe7/wallet.svg";
import { ReactComponent as Icon_world } from "src/assets/icons/pe7/world.svg";

const pe7IconMap = {
  "pe-7s-add-user": Icon_add_user,
  "pe-7s-alarm": Icon_alarm,
  "pe-7s-albums": Icon_albums,
  "pe-7s-angle-down": Icon_angle_down,
  "pe-7s-angle-left-circle": Icon_angle_left_circle,
  "pe-7s-angle-right-circle": Icon_angle_right_circle,
  "pe-7s-angle-up": Icon_angle_up,
  "pe-7s-attention": Icon_attention,
  "pe-7s-back": Icon_back,
  "pe-7s-ball": Icon_ball,
  "pe-7s-bell": Icon_bell,
  "pe-7s-bookmarks": Icon_bookmarks,
  "pe-7s-box2": Icon_box2,
  "pe-7s-car": Icon_car,
  "pe-7s-cart": Icon_cart,
  "pe-7s-cash": Icon_cash,
  "pe-7s-chat": Icon_chat,
  "pe-7s-check": Icon_check,
  "pe-7s-close": Icon_close,
  "pe-7s-cloud": Icon_cloud,
  "pe-7s-coffee": Icon_coffee,
  "pe-7s-comment": Icon_comment,
  "pe-7s-config": Icon_config,
  "pe-7s-copy-file": Icon_copy_file,
  "pe-7s-credit": Icon_credit,
  "pe-7s-cup": Icon_cup,
  "pe-7s-delete-user": Icon_delete_user,
  "pe-7s-diamond": Icon_diamond,
  "pe-7s-display1": Icon_display1,
  "pe-7s-display2": Icon_display2,
  "pe-7s-download": Icon_download,
  "pe-7s-drawer": Icon_drawer,
  "pe-7s-edit": Icon_edit,
  "pe-7s-filter": Icon_filter,
  "pe-7s-folder": Icon_folder,
  "pe-7s-gift": Icon_gift,
  "pe-7s-graph": Icon_graph,
  "pe-7s-graph1": Icon_graph1,
  "pe-7s-graph2": Icon_graph2,
  "pe-7s-gym": Icon_gym,
  "pe-7s-help1": Icon_help1,
  "pe-7s-home": Icon_home,
  "pe-7s-id": Icon_id,
  "pe-7s-lock": Icon_lock,
  "pe-7s-magic-wand": Icon_magic_wand,
  "pe-7s-mail": Icon_mail,
  "pe-7s-map": Icon_map,
  "pe-7s-medal": Icon_medal,
  "pe-7s-monitor": Icon_monitor,
  "pe-7s-network": Icon_network,
  "pe-7s-news-paper": Icon_news_paper,
  "pe-7s-next": Icon_next,
  "pe-7s-note2": Icon_note2,
  "pe-7s-notebook": Icon_notebook,
  "pe-7s-phone": Icon_phone,
  "pe-7s-photo-gallery": Icon_photo_gallery,
  "pe-7s-piggy": Icon_piggy,
  "pe-7s-plane": Icon_plane,
  "pe-7s-plugin": Icon_plugin,
  "pe-7s-plus": Icon_plus,
  "pe-7s-refresh": Icon_refresh,
  "pe-7s-repeat": Icon_repeat,
  "pe-7s-settings": Icon_settings,
  "pe-7s-shopbag": Icon_shopbag,
  "pe-7s-shuffle": Icon_shuffle,
  "pe-7s-smile": Icon_smile,
  "pe-7s-star": Icon_star,
  "pe-7s-study": Icon_study,
  "pe-7s-sun": Icon_sun,
  "pe-7s-tools": Icon_tools,
  "pe-7s-unlock": Icon_unlock,
  "pe-7s-user": Icon_user,
  "pe-7s-users": Icon_users,
  "pe-7s-wallet": Icon_wallet,
  "pe-7s-world": Icon_world,
};

export default pe7IconMap;
